import { Dispatch } from 'redux';

import {
  listenToWebsocket,
  startWebsocket,
} from '#/api/services/webSocketApiService';
import { MAINTENANCE_MODE, RELOAD_NOTICES_DELAY_MS } from '#/config/constants';
import { fetchAndDispatchUser } from '#/reduxState/currentUser/currentUserUtils';
import { fetchAndDispatchNotices } from '#/reduxState/notices/noticesReducerUtils';

import { getActiveChainFromState } from './exchange/exchangeActiveChain';
import { isChainListed } from './exchange/exchangeActiveChainUtils';
import { getStateOutsideOfComponent } from './store';

import type { ReduxActions } from './storeCore';

export async function initialMiddleware(dispatch: Dispatch<ReduxActions>) {
  const activeChain = getActiveChainFromState();
  const chainListed = isChainListed(activeChain);

  if (MAINTENANCE_MODE) {
    console.warn('MAINTENANCE_MODE enabled');
    return;
  }

  const { wallet } = await getStateOutsideOfComponent();

  // Check valid user session
  fetchAndDispatchUser(dispatch)
    .catch(console.error)
    .then(() => startWebsocket(wallet.walletAddress))
    .catch(console.warn)
    .then(() => {
      setTimeout(() => {
        fetchAndDispatchNotices(dispatch);
      }, 2000);
    });

  listenToWebsocket('webclient', message => {
    // if (event.data.e === 'user_profile_updated') {
    //   console.log('[initialMiddleware] User profile was updated, re-fetching');
    //   setTimeout(() => fetchAndDispatchUser(dispatch), USER_UPDATE_DELAY_MS);
    // }
    if (message.data.event === 'reload_banners') {
      console.log(
        'Banner reload initialized (expect banner change in up to 15 seconds)'
      );
      // Delayed reload of baners, so users don't hit API at once
      setTimeout(
        () => fetchAndDispatchNotices(dispatch),
        RELOAD_NOTICES_DELAY_MS
      );
    }
  });

  if (!chainListed) {
    return;
  }

  // if (COMPETITION_ENABLED) {
  //   const fetchCompetition = () =>
  //     fetchUserLeaderboard()
  //       .then(response => {
  //         dispatch(
  //           setYourLeaderInfo({
  //             participants: response.numberOfParticipants,
  //             rank: response.rank,
  //             totalUsdValue: response.totalUsdValue,
  //           })
  //         );
  //       })
  //       .catch(error => {
  //         console.warn(error);
  //       });
  //   fetchCompetition();
  //   setInterval(fetchCompetition, 20000);
  // }
}

/**
 * We need to handle removing of old handlers when we hot reload or else each hot reload adds more and more
 * requests to that are made to the API.
 */
// if (module.hot) {
//   module.hot.dispose(() => {
//     window.clearTimeout(intervalID);
//   });
// }
